import { config } from '@/config/config';

import type { NotificationEntityAction } from './types';

export const notificationsEndpoints = {
  notifications: '/notifications',

  readNotification: '/notifications/{id}/read',
  readAllNotifications: '/notifications/read',
  unreadNotification: '/notifications/{id}/unread',
} as const;

const jobsPageLink = '/jobs';
const jobCandidatesLink = '/jobs/{id}/candidates';
const messagingLink = '/messaging';

export const notificationLinks: Record<NotificationEntityAction, string> = {
  JobCreated: jobCandidatesLink,
  SourcingStarted: jobCandidatesLink,
  SourcingFailed: jobCandidatesLink,
  SourcingFinished: jobCandidatesLink,
  ManualUploadFinished: jobCandidatesLink,
  ManualUploadFailed: jobCandidatesLink,
  NewMessage: `${messagingLink}?tab=conversations&threadId={id}`,
  OutreachGenerated: `${messagingLink}?tab=drafts&messageId={id}`,
  JobImportSuccess: jobsPageLink,
  JobImportFailed: jobsPageLink,
  MessageReviewRequired: `${messagingLink}?tab=conversations&threadId={id}`,
} as const;

export const NOTIFICATION_HUB_URL = `${config.app.apiBaseUrl}/hubs/notifications`;
